/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A balanced 30/40/30 works for most goals. Low-carb suits some people for fat loss; high-protein helps preserve muscle in a calorie deficit.`)
};

const es_macro_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un reparto equilibrado 30/40/30 funciona para la mayoría de los objetivos. El bajo en carbohidratos le va bien a algunas personas para perder grasa; el alto en proteína ayuda a conservar músculo en un déficit calórico.`)
};

const de_macro_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine ausgewogene 30/40/30-Verteilung eignet sich für die meisten Ziele. Kohlenhydratarm passt für manche beim Fettabbau; proteinreich hilft, Muskeln im Kaloriendefizit zu erhalten.`)
};

const nl_macro_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een uitgebalanceerde verdeling van 30/40/30 werkt voor de meeste doelen. Koolhydraatarm past bij sommige mensen voor vetverlies; eiwitrijk helpt spieren te behouden bij een calorietekort.`)
};

const fr_macro_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une répartition équilibrée 30/40/30 convient à la plupart des objectifs. Pauvre en glucides convient à certains pour la perte de graisse ; riche en protéines aide à préserver le muscle en déficit calorique.`)
};

const it_macro_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una ripartizione bilanciata 30/40/30 va bene per la maggior parte degli obiettivi. Il low-carb è adatto a chi vuole perdere grasso; il ricco di proteine aiuta a preservare i muscoli in deficit calorico.`)
};

const pt_br2_macro_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma divisão equilibrada 30/40/30 funciona para a maioria dos objetivos. Low-carb serve para algumas pessoas na perda de gordura; hiperproteica ajuda a preservar músculo em déficit calórico.`)
};

const pt_macro_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma divisão equilibrada 30/40/30 funciona para a maioria dos objetivos. A baixa em hidratos ajuda algumas pessoas na perda de gordura; a rica em proteína ajuda a preservar o músculo num défice calórico.`)
};

const ja_macro_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バランス型の30/40/30はほとんどの目標に適しています。低炭水化物型は脂肪減少に向く人もおり、高タンパク型はカロリー制限中の筋肉維持に役立ちます。`)
};

const zh_macro_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`均衡型 30/40/30 适合大多数目标。低碳型适合部分人减脂；高蛋白型有助于在热量缺口下保留肌肉。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_faq_a3", locale)
	if (locale === "en") return en_macro_faq_a3(inputs)
	if (locale === "es") return es_macro_faq_a3(inputs)
	if (locale === "de") return de_macro_faq_a3(inputs)
	if (locale === "nl") return nl_macro_faq_a3(inputs)
	if (locale === "fr") return fr_macro_faq_a3(inputs)
	if (locale === "it") return it_macro_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_macro_faq_a3(inputs)
	if (locale === "pt") return pt_macro_faq_a3(inputs)
	if (locale === "ja") return ja_macro_faq_a3(inputs)
	return zh_macro_faq_a3(inputs)
};